import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, HostBinding, OnDestroy, OnInit } from '@angular/core';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { LanguageService } from '../language.service';

gsap.registerPlugin(ScrollTrigger);

@Component({
    selector: 'app-press',
    templateUrl: './press.component.html',
    styleUrls: ['./press.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PressComponent implements OnInit, AfterViewInit, OnDestroy {
  @HostBinding('class.animations-enabled')
  public readonly animationsEnabled = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  private animationContext?: gsap.Context;

  constructor(
    private readonly elementRef: ElementRef<HTMLElement>,
    public readonly language: LanguageService,
  ) { }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    if (!this.animationsEnabled) return;

    this.animationContext = gsap.context(() => {
      gsap.timeline({ defaults: { ease: 'power3.out' } })
        .from('.eyebrow', { autoAlpha: 0, y: 14, duration: .5 })
        .from('.press-hero h1 span, .press-hero h1 em', { autoAlpha: 0, y: 38, duration: .9, stagger: .16 }, '-=.25')
        .from('.intro', { autoAlpha: 0, x: 22, duration: .75 }, '-=.55');

      const cards = gsap.utils.toArray<HTMLElement>('.press-card');
      const reveal = (items: Element[]): void => {
        gsap.to(items, { opacity: 1, y: 0, duration: 1.05, stagger: .12, ease: 'power2.out', overwrite: true });
      };

      ScrollTrigger.batch(cards, { start: 'top 91%', onEnter: reveal, onEnterBack: reveal });
      requestAnimationFrame(() => ScrollTrigger.refresh());
    }, this.elementRef.nativeElement);
  }

  ngOnDestroy(): void {
    this.animationContext?.revert();
  }

}
